const getNotificationStatus = (notification) => {
    const { opened, isNewNotification, isPinned } = notification;
    if (isPinned) {
        return 'pinned';
    }
    if (isNewNotification) {
        return 'new';
    }
    if (opened) {
        return 'opened';
    }
    return 'unopened';
};
export default getNotificationStatus;
